var map = {
	"./add.svg": "c2e4",
	"./alarm.svg": "a619",
	"./camera.svg": "630f",
	"./d2-admin-text.svg": "ae5c",
	"./d2-admin.svg": "bb12",
	"./d2-crud.svg": "069e",
	"./history.svg": "9cd8",
	"./like.svg": "18c4",
	"./love.svg": "22dc",
	"./message.svg": "6f6e",
	"./notice.svg": "7cf9",
	"./search.svg": "5cdc",
	"./share.svg": "7b94",
	"./star.svg": "ad22",
	"./user.svg": "aa614"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec39";